import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import {
  SearchResults as DefaultSearchResults,
} from '@uncinc/react-searchkit';

import { REQUEST_TYPE_MAATJE_WORDEN } from '../../../config/constants';
import { getActiveRequestType } from '../../../helpers';

import './style.scss';

const Item = ({ hit, type }) => {
  const { t } = useTranslation();
  let url = hit.url[0];

  return (
    <div className="Search__result_item">
      <CoreLink href={`${url}?type=${type}`}>
        <div className="row">
          <div className="col-12">
            <div className="Search__result_item__title">
              <h4>{hit.title[0]}</h4>
            </div>
            {hit.field_organization && (
              <div className="Search__result_item__detail">
                <span className="Search__result_item__detail__title">{t('maatjes_search.fields.organisation.label')} </span>
                <span className="Search__result_item__detail__body">{hit.field_organization[0]}</span>
              </div>
            )}
            {hit.field_project_type && (
              <div className="Search__result_item__detail">
                <span className="Search__result_item__detail__title">{t('maatjes_search.fields.project_type.label')} </span>
                <span className="Search__result_item__detail__body">{hit.field_project_type.join(', ')}</span>
              </div>
            )}
            {hit.field_weekly_time_spent && (
              <div className="Search__result_item__detail">
                <span className="Search__result_item__detail__title">{t('maatjes_search.fields.weekly_time_spent.label')} </span>
                <span className="Search__result_item__detail__body">{hit.field_weekly_time_spent[0]}</span>
              </div>
            )}
          </div>
          {hit.body && (
            <div className="col-12">
              <div className="Search__result_item__body">
                <div className="Search__result_item__body__text">
                  <WysiwygField
                    property="schema:text"
                    html={(type === REQUEST_TYPE_MAATJE_WORDEN || !hit.body_secondary) ? hit.body[0] : hit.body_secondary[0]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </CoreLink>
    </div>
  );
};

const SearchResults = () => {
  const { t } = useTranslation();
  const activeRequestType = getActiveRequestType();

  return (
    <div className="SearchResults">
      <DefaultSearchResults
        renderItem={(hit) => <Item hit={hit} type={activeRequestType} />}
        emptyState={(
          <div className="SearchResults__no_results">
            {t('search.no_results')}
          </div>
        )}
      />
    </div>
  );
};

export default SearchResults;
